module.exports = __webpack_public_path__ + "static/media/team-icon.9bb2d222.svg";